export default "__VITE_ASSET__qhPeisu$__"